import moment from 'moment';
import { dataLayerSendEvent as sendEventData } from '@common/Utility/analytics-utils';
import { PAGE_NAME, MY_ASTER_CATEGORY, PAGE_TYPE } from '@common/Constants/analytics'; 

export const dataLayerSendEvent = (eventName, data) => {
  sendEventData(eventName, data);
};

export const labReportView = (reportDetail) => {

  const userType = () => {
    if (reportDetail?.length !== 0) {
      return reportDetail?.length === 1 ? 'single user' : 'multiple users';
    }
  };

  const userStatus = () => {
    if (reportDetail?.length !== 0) {
      if (
        reportDetail?.every((item) =>
          item?.appointments?.every((labTest) =>
            labTest?.labResults?.labTests?.every((test) => test?.status === 'Completed'),
          )
        )
      ) {
        return 'ready';
      }
      return 'in progress';
    }
  };

  const itemData = {
    screen_name: PAGE_NAME?.HOME,
    page_type: PAGE_NAME?.ASCO,
    status: userStatus(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    type: userType(),
  };
  dataLayerSendEvent('lab_reports_card_viewed', itemData);
};

export const labReportCardExpand = (reportDetail, Selection) => {

  const userType = () => {
    if (reportDetail?.length !== 0) {
      return reportDetail?.length === 1 ? 'single user' : 'multiple users';
    }
  };

  const userStatus = () => {
    if (reportDetail?.length !== 0) {
      if (
        reportDetail?.every((item) =>
          item?.appointments?.every((labTest) =>
            labTest?.labResults?.labTests?.every((test) => test?.status === 'Completed'),
          )
        )
      ) {
        return 'ready';
      }
      return 'in progress';
    }
  };

  const itemData = {
    screen_name: PAGE_NAME?.HOME,
    page_type: PAGE_NAME?.ASCO,
    status: userStatus(),
    selection: Selection,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    type: userType(),
  };
  dataLayerSendEvent('lab_reports_card_clicked', itemData);
};

export const labReportCardClick = (reportDetail, appointment) => {

  const userType = () => {
    if (reportDetail?.length !== 0) {
      return reportDetail?.length === 1 ? 'single user' : 'multiple users';
    }
  };

  const userStatus = () => {
    if (reportDetail?.length !== 0) {
      if (
        reportDetail?.every((item) =>
          item?.appointments?.every((labTest) =>
            labTest?.labResults?.labTests?.every((test) => test?.status === 'Completed'),
          )
        )
      ) {
        return 'ready';
      }
      return 'in progress';
    }
  };

  const getConvertedDate = (aptDate) => moment(aptDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

  const itemData = {
    screen_name: PAGE_NAME?.HOME,
    page_type: PAGE_NAME?.ASCO,
    status: userStatus(),
    doctor_name: appointment?.doctorName,
    appointment_date: getConvertedDate(appointment?.appointmentDate),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    type: userType(),
  };
  dataLayerSendEvent('lab_reports_details_click', itemData);
};

